module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/pages--board-directors.43fe73e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/pages--board-directors.pdf
// module id = 3OHP
// module chunks = 10